import * as React from "react"
import { Link } from "gatsby"
import { Layout } from "../components/layout"
import { StoreContext } from "../context/store-context"
import { LineItem } from "../components/line-item"
import { formatPrice } from "../utils/format-price"
import { InstagramFeed } from "../components/homepageComponents"
import {
  table,
  wrap,
  totals,
  grandTotal,
  summary,
  checkoutButton,
  collapseColumn,
  labelColumn,
  imageHeader,
  productHeader,
  emptyStateContainer,
  emptyStateHeading,
  emptyStateLink,
  title,
} from "./cart.module.css"
import { IngredientLibraryHomePageSection } from "../components/homepageComponents"
import { styled } from '../styles/stitches.config'
import { Seo } from "../components/seo"

export default function CartPage() {
  const { checkout, loading } = React.useContext(StoreContext)
  const emptyCart = checkout.lineItems.length === 0

  const CheckoutButton = styled('button', {
    fontFamily: '$lato',
    color: 'white',
    padding: '14px 40px',
    backgroundColor: 'black',
    textTransform: 'uppercase',
    maxWidth: '200px',
    margin: '40px auto 20px auto',
  });

  const Totals = styled('div', {
    fontFamily: '$lato',
    // maxWidth: '1024px',
    display: 'grid',
    // padding: '0 20px',
    gridTemplateColumns: '1fr 1fr',
    textAlign: 'right',
    h4: {
      fontSize: '24px',
      fontWeight: 'bold',
    }
  });

  const handleCheckout = () => {
    window.open(checkout.webUrl)
  }

  return (
    <Layout>
      <Seo title={'Cart - Better Days Skin Co.'} />
      <div className={wrap}>
        {emptyCart ? (
          <div className={emptyStateContainer}>
            <h1 className={emptyStateHeading}>Your cart is empty</h1>
            <p>
              Don&apos;t be shy, add our <Link to={'/products/multi-active-treatment-essence'}>Multi-Active Treatment Essence!</Link>
            </p>
            {/* <Link to="/search?s=BEST_SELLING" className={emptyStateLink}>
              View trending products
            </Link> */}
          </div>
        ) : (
          <>
            <h1 className={title}>Your cart</h1>
            <table className={table}>
              <thead>
                <tr>
                  {/* <th className={imageHeader}>Image</th> */}
                  <th className={productHeader}>Product</th>
                  {/* <th className={collapseColumn}>Price</th> */}
                  <th>Qty.</th>
                  <th className={[totals, collapseColumn].join(" ")}>Total</th>
                </tr>
              </thead>
              <tbody>
                {checkout.lineItems.map((item) => (
                  <LineItem item={item} key={item.id} />
                ))}
              </tbody>
            </table>
            <Totals>
              <div style={{ textAlign: 'left' }}>
                <h5>Subtotal</h5>
              </div>
              <div>
                {formatPrice(
                  checkout.subtotalPriceV2.currencyCode,
                  checkout.subtotalPriceV2.amount
                )}
              </div>
              <div style={{ textAlign: 'left' }}>
                Shipping
              </div>
              <div>
                Calculated at checkout
              </div>
              <div style={{ textAlign: 'left' }}>
                <h4>Total Price</h4>
              </div>
              <div>
                <h4>
                  {formatPrice(
                    checkout.totalPriceV2.currencyCode,
                    checkout.totalPriceV2.amount
                  )}
                </h4>
              </div>
            </Totals>
            <div style={{ display: 'flex', justifyContent: 'center', flexFlow: 'column wrap' }}>
              <CheckoutButton
                onClick={handleCheckout}
                disabled={loading}
              // className={checkoutButton}
              >
                Checkout
              </CheckoutButton>
              <p style={{ color: '#585d6c', textAlign: 'center', fontSize: '12px', marginBottom: '40px' }}>If you have a discount code, you can add this once you proceed to the checkout page!</p>
            </div>
          </>
        )}
      </div>
      {/* <InstagramFeed /> */}
    </Layout>
  )
}
